import Image from "next/image";
import FadeIn from "react-fade-in";

import { useAppState } from "@src/state";
import { useJobSearch } from "@src/state/jobSearch";

import HamburgerMenuIcon from "@components/HamburgerMenuIcon";
import Close from "@assets/close-button.png";
import Logo from "@assets/logo_10.png";

import styles from "../style.module.css";
import localStyles from "./style.module.css";
import Filter from "icons/Filter";
import Link from "next/link";

export default function MobileSearchNav({
  mobileMenu,
  openMobileMenu,
  closeMobileMenu,
  closing,
}) {
  const { state: appState } = useAppState();
  const { dispatch } = useJobSearch();

  const handleOpen = () => {
    dispatch({ type: "setFilter", payload: true });
  };

  return (
    <div
      className={`${mobileMenu ? styles.navOpenWrapper : ""} ${
        styles.mobileHeader
      }`}
    >
      <div
        className={
          mobileMenu ? styles.mobileNavOpen : localStyles.mobileNavClosed
        }
      >
        <div
          onClick={handleOpen}
          className={localStyles.filter}
          style={{ display: mobileMenu ? "none" : "initial" }}
        >
          <Filter />
        </div>
        {!appState?.mobileMenu && !closing && (
          <div
            className={styles.fade}
            style={{ position: "relative", top: "3px" }}
          >
            <Link href="/" passHref>
              <Image src={Logo} alt="logo" width={40} height={40} />
            </Link>
          </div>
        )}
        {appState.mobileMenu && (
          <div className={styles.mobileMenuLogo}>
            <FadeIn>
              <Image src={Logo} alt="logo" width={40} height={40} />
            </FadeIn>
          </div>
        )}
        {!appState?.mobileMenu && (
          <div className={styles.menuIcon} onClick={openMobileMenu}>
            <HamburgerMenuIcon mobile />
          </div>
        )}

        {appState.mobileMenu && (
          <div
            className={`${styles.menuIcon} ${styles.closeIcon}`}
            onClick={closeMobileMenu}
          >
            <Image
              src={Close}
              className={styles.closeButton}
              width={20}
              height={20}
              alt="close menu"
            />
          </div>
        )}
      </div>
    </div>
  );
}
